import { z } from 'zod';

export const VehicleEnginePreviewSchema = z.object({
  id: z.uuid(),
  description: z.string(),
  displacementCc: z.number().int().nonnegative().nullable(),
});

export const VehicleGenerationPreviewSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
});

export const VehicleTrimPreviewSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  slug: z.string(),
});

export const CreateVehicleApplicationBodySchema = z.object({
  vehicleModelId: z.uuid().optional(),
  manufactureYearStart: z.number().int().min(1900).max(2100).optional(),
  manufactureYearEnd: z.number().int().min(1900).max(2100).optional(),
  vehicleEngineIds: z.array(z.uuid()).default([]),
  vehicleGenerationIds: z.array(z.uuid()).default([]),
  vehicleTrimIds: z.array(z.uuid()).default([]),
  freeApplication: z.string().trim().max(2000).optional(),
});

export const UpdateVehicleApplicationBodySchema = z.object({
  vehicleModelId: z.uuid().nullable().optional(),
  manufactureYearStart: z.number().int().min(1900).max(2100).nullable().optional(),
  manufactureYearEnd: z.number().int().min(1900).max(2100).nullable().optional(),
  vehicleEngineIds: z.array(z.uuid()).optional(),
  vehicleGenerationIds: z.array(z.uuid()).optional(),
  vehicleTrimIds: z.array(z.uuid()).optional(),
  freeApplication: z.string().trim().max(2000).nullable().optional(),
});

export const ReplaceProductModelVehicleApplicationsBodySchema = z.object({
  items: z.array(
    z.object({
      vehicleModelId: z.uuid(),
      manufactureYearStart: z.number().int().min(1900).max(2100),
      manufactureYearEnd: z.number().int().min(1900).max(2100).optional(),
      vehicleEngineIds: z.array(z.uuid()).default([]),
      vehicleGenerationIds: z.array(z.uuid()).default([]),
      vehicleTrimIds: z.array(z.uuid()).default([]),
    }),
  ),
});

export const CreateVehicleApplicationResponseSchema = z.object({
  applicationId: z.uuid(),
});

export const VehicleApplicationListItemSchema = z.object({
  id: z.uuid(),
  vehicleModelId: z.uuid().nullable(),
  manufactureYearStart: z.number().int().nullable(),
  manufactureYearEnd: z.number().int().nullable(),
  freeApplication: z.string().nullable(),
  engines: z.array(VehicleEnginePreviewSchema),
  generations: z.array(VehicleGenerationPreviewSchema).default([]),
  trims: z.array(VehicleTrimPreviewSchema).default([]),
});

export const ListVehicleApplicationsResponseSchema = z.object({
  items: z.array(VehicleApplicationListItemSchema),
});

export type CreateVehicleApplicationBody = z.infer<typeof CreateVehicleApplicationBodySchema>;
export type UpdateVehicleApplicationBody = z.infer<typeof UpdateVehicleApplicationBodySchema>;
export type ReplaceProductModelVehicleApplicationsBody = z.infer<
  typeof ReplaceProductModelVehicleApplicationsBodySchema
>;
export type CreateVehicleApplicationResponse = z.infer<
  typeof CreateVehicleApplicationResponseSchema
>;
export type ListVehicleApplicationsResponse = z.infer<typeof ListVehicleApplicationsResponseSchema>;
